// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2371717a%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/*
  Design tokens — soft UI + Azul Safira sóbrio
  - Accent: #2B6CB0 (quebra o excesso de cinza)
  - Neutros mantêm superfícies e tipografia equilibradas
*/
:root {
  /* ——— Neutrals ——— */
  --color-bg: #e8e8e8;
  --color-bg-subtle: #f0f0f0;
  --color-surface: #ffffff;
  --color-surface-muted: #f3f3f3;
  --color-text: #1a1a1a;
  --color-text-secondary: #404040;
  --color-text-muted: #666666;
  --color-text-inverse: #fafafa;

  /* ——— Accent: Azul Safira Sóbrio (destaque em todo o sistema) ——— */
  --color-accent: #2b6cb0;
  --color-accent-hover: #245a96;
  --color-accent-active: #1e4d82;
  --color-accent-fg: #ffffff;
  --color-accent-muted: rgba(43, 108, 176, 0.1);
  --color-accent-border: rgba(43, 108, 176, 0.28);
  --color-accent-soft: rgba(43, 108, 176, 0.14);
  /* Badges/tags de destaque (ultra-suave) */
  --color-accent-badge-bg: #ebf8ff;
  --color-accent-badge-fg: #2b6cb0;
  --color-accent-badge-border: rgba(43, 108, 176, 0.14);

  /* Emphasis = Accent (CTAs, abas ativas, punch next, etc.) */
  --color-emphasis: var(--color-accent);
  --color-emphasis-fg: var(--color-accent-fg);
  --color-emphasis-hover: var(--color-accent-hover);
  --color-emphasis-muted: var(--color-accent-muted);
  --color-emphasis-border: var(--color-accent-border);

  /* Primary = accent */
  --color-primary: var(--color-accent);
  --color-primary-hover: var(--color-accent-hover);
  --color-primary-active: var(--color-accent-active);
  --color-primary-fg: var(--color-accent-fg);
  --color-primary-muted: var(--color-accent-muted);
  --color-primary-border: var(--color-accent-border);
  /* soft = pastel (nunca sólido — evita texto ilegível em avatares/chips) */
  --color-primary-soft: var(--color-accent-badge-bg);
  --color-primary-soft-hover: var(--color-accent-muted);

  /* Semântica suave (badges/tags — pastel dessaturado + texto escuro) */
  --color-danger: #991b1b;
  --color-danger-muted: #fef2f2;
  --color-success: #166534;
  --color-success-muted: #f0fdf4;
  --color-warning: #9a3412;
  --color-warning-muted: #fff7ed;
  --color-info: var(--color-accent);
  --color-info-muted: rgba(43, 108, 176, 0.1);

  /* ——— Borders (sutis, baixa opacidade) ——— */
  --border-subtle: rgba(23, 23, 23, 0.06);
  --border-default: rgba(23, 23, 23, 0.09);
  --border-strong: rgba(23, 23, 23, 0.14);
  --border-divider: rgba(23, 23, 23, 0.045);

  /* ——— Radius ——— */
  --radius-sm: 8px;
  --radius-md: 10px;
  --radius-lg: 12px;
  --radius-full: 12px;
  --input-radius: 10px;
  --badge-radius: 8px;

  /* ——— Elevation ——— */
  --shadow-none: none;
  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.03);
  --shadow-sm: 0 4px 16px -6px rgba(0, 0, 0, 0.04);
  --shadow-md: 0 10px 30px -10px rgba(0, 0, 0, 0.04);
  --shadow-card: 0 10px 30px -10px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);
  --shadow-elevated: 0 16px 40px -12px rgba(0, 0, 0, 0.08), 0 4px 14px -6px rgba(0, 0, 0, 0.04);
  --elevation-border: 1px solid var(--border-subtle);
  --focus-border-color: rgba(43, 108, 176, 0.5);
  --focus-ring: 0 0 0 3px rgba(43, 108, 176, 0.16);
  --focus-ring-accent: 0 0 0 3px rgba(43, 108, 176, 0.18);

  /* ——— Superfícies ——— */
  --surface-radius: 14px;
  --surface-pad: 24px;
  --surface-pad-lg: 28px;
  --surface-gap: 20px;

  /* ——— Button tokens ——— */
  --btn-radius: 10px;
  --btn-radius-sm: 8px;
  --btn-shadow: none;
  --btn-transition: border-color 200ms ease, background-color 200ms ease, color 200ms ease;
  --btn-secondary-bg: #ffffff;
  --btn-secondary-border: var(--border-default);
  --btn-secondary-fg: var(--color-text-secondary);
  --btn-secondary-hover-bg: #ffffff;
  --btn-secondary-hover-border: var(--color-accent);
  --btn-secondary-hover-fg: var(--color-accent);
  --btn-primary-bg: var(--color-accent);
  --btn-primary-hover: var(--color-accent-hover);
  --btn-primary-fg: var(--color-accent-fg);

  /* ——— Chrome: header glass + heroes ——— */
  --surface-elevated: var(--color-surface);
  --color-chrome: #eef3f9;
  --color-chrome-gradient: linear-gradient(165deg, #f8fafc 0%, #eef3f9 52%, #e4ecf6 100%);
  --color-chrome-border: rgba(43, 108, 176, 0.1);
  --color-chrome-inset: inset 0 1px 0 rgba(255, 255, 255, 0.65);
  --color-header-glass: rgba(255, 255, 255, 0.62);
  --color-header-glass-blur: blur(14px) saturate(180%);
  --color-hero: var(--color-chrome);
  --color-hero-fg: #1a1a1a;
  --color-hero-muted: #4a5568;
  --color-hero-gradient: var(--color-chrome-gradient);
  --color-page-gradient: linear-gradient(180deg, #e8eef5 0%, #e6e9ee 52%, #e3e5e8 100%);

  /* ——— Legacy aliases ——— */
  --surface-border: var(--border-subtle);
  --surface-card: var(--color-surface);
  --option-bg: var(--color-surface-muted);
  --option-border: var(--border-subtle);
  --option-hover-bg: var(--color-bg-subtle);
  --option-focus-ring: var(--focus-ring);
  --primary-gradient: var(--color-primary-soft);
  --primary-shadow: var(--btn-shadow);
}

body {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--color-page-gradient);
  background-color: var(--color-bg);
  color: var(--color-text);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.card {
  background: var(--surface-card);
  border: var(--elevation-border);
  border-radius: var(--surface-radius);
  padding: var(--surface-pad);
  margin-bottom: var(--surface-gap);
  box-shadow: var(--shadow-card);
}

.btn {
  padding: 10px 20px;
  border: 1px solid transparent;
  border-radius: var(--btn-radius);
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: var(--btn-transition);
}

.btn-primary {
  background: var(--btn-primary-bg);
  color: var(--btn-primary-fg);
  box-shadow: none;
  border-color: var(--color-primary);
}

.btn-primary:hover {
  background: var(--btn-primary-hover);
  border-color: var(--btn-primary-hover);
  color: var(--btn-primary-fg);
  filter: none;
  transform: none;
}

.btn-primary:active {
  background: var(--color-primary-active);
  border-color: var(--color-primary-active);
  box-shadow: var(--shadow-none);
}

.btn-secondary {
  background: var(--btn-secondary-bg);
  color: var(--btn-secondary-fg);
  border-color: var(--btn-secondary-border);
  box-shadow: var(--shadow-xs);
}

.btn-secondary:hover {
  background: var(--btn-secondary-hover-bg);
  border-color: var(--btn-secondary-hover-border);
  color: var(--btn-secondary-hover-fg);
}

.btn-secondary:focus-visible {
  outline: none;
  border-color: var(--color-accent);
  color: var(--color-accent);
  box-shadow: var(--focus-ring);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-default);
  border-radius: var(--input-radius);
  background: var(--color-surface);
  color: var(--color-text);
  font-size: 0.95rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.form-group select {
  min-height: 44px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  padding-right: 40px;
  background-color: var(--color-surface);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px 16px;
}

.form-group input:hover,
.form-group select:hover,
.form-group textarea:hover {
  border-color: var(--border-default);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border: 2px solid var(--focus-border-color);
  background-color: var(--color-surface);
  box-shadow: var(--focus-ring);
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

/* Links de texto em prosa — não aplicar a CTAs/Links estilizados como botão */
.app-main p a,
.app-main li a,
.app-main .dashboard-support-text a,
.app-main .feedbacks-empty-card a,
.app-main a.app-text-link {
  color: var(--color-accent);
  text-decoration-color: color-mix(in srgb, var(--color-accent) 35%, transparent);
  text-underline-offset: 2px;
}

.app-main p a:hover,
.app-main li a:hover,
.app-main .dashboard-support-text a:hover,
.app-main .feedbacks-empty-card a:hover,
.app-main a.app-text-link:hover {
  color: var(--color-accent-hover);
}

/* Badge / tag utilitário — cantos soft, pastel dessaturado */
.ui-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: var(--badge-radius);
  border: 1px solid transparent;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.3;
  box-sizing: border-box;
  background: var(--color-surface-muted);
  color: var(--color-text-secondary);
}

.ui-badge--accent {
  background: var(--color-accent-badge-bg);
  color: var(--color-accent-badge-fg);
  border-color: var(--color-accent-badge-border);
}

.ui-badge--success {
  background: var(--color-success-muted);
  color: var(--color-success);
  border-color: color-mix(in srgb, var(--color-success) 12%, transparent);
}

.ui-badge--warning {
  background: var(--color-warning-muted);
  color: var(--color-warning);
  border-color: color-mix(in srgb, var(--color-warning) 12%, transparent);
}

.ui-badge--danger {
  background: var(--color-danger-muted);
  color: var(--color-danger);
  border-color: color-mix(in srgb, var(--color-danger) 12%, transparent);
}

.ui-badge--info {
  background: var(--color-info-muted);
  color: var(--color-info);
  border-color: color-mix(in srgb, var(--color-info) 10%, transparent);
}

.ui-badge--neutral {
  background: var(--color-surface-muted);
  color: var(--color-text-secondary);
  border-color: var(--border-subtle);
}

/* Tabelas base — divisores suaves + hover discreto */
.ui-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.ui-table th,
.ui-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid var(--border-divider);
}

.ui-table tbody tr {
  transition: background-color 0.15s ease;
}

.ui-table tbody tr:hover {
  background: color-mix(in srgb, var(--color-emphasis) 3.5%, transparent);
}

.error {
  color: var(--color-danger);
  margin-top: 5px;
}

.success {
  color: var(--color-success);
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;;CAIC;AACD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;;EAE7B,oEAAoE;EACpE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,6CAA6C;EAC7C,+CAA+C;EAC/C,6CAA6C;EAC7C,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,qDAAqD;;EAErD,4DAA4D;EAC5D,qCAAqC;EACrC,2CAA2C;EAC3C,iDAAiD;EACjD,iDAAiD;EACjD,mDAAmD;;EAEnD,qBAAqB;EACrB,oCAAoC;EACpC,gDAAgD;EAChD,kDAAkD;EAClD,0CAA0C;EAC1C,gDAAgD;EAChD,kDAAkD;EAClD,0EAA0E;EAC1E,kDAAkD;EAClD,qDAAqD;;EAErD,sEAAsE;EACtE,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,2CAA2C;;EAE3C,6CAA6C;EAC7C,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;;EAEzC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;;EAEnB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,gDAAgD;EAChD,kDAAkD;EAClD,mFAAmF;EACnF,6FAA6F;EAC7F,kDAAkD;EAClD,6CAA6C;EAC7C,gDAAgD;EAChD,uDAAuD;;EAEvD,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;;EAEnB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,wFAAwF;EACxF,2BAA2B;EAC3B,6CAA6C;EAC7C,+CAA+C;EAC/C,iCAAiC;EACjC,iDAAiD;EACjD,6CAA6C;EAC7C,qCAAqC;EACrC,8CAA8C;EAC9C,wCAAwC;;EAExC,0CAA0C;EAC1C,wCAAwC;EACxC,uBAAuB;EACvB,uFAAuF;EACvF,8CAA8C;EAC9C,6DAA6D;EAC7D,+CAA+C;EAC/C,oDAAoD;EACpD,iCAAiC;EACjC,wBAAwB;EACxB,2BAA2B;EAC3B,mDAAmD;EACnD,qFAAqF;;EAErF,2BAA2B;EAC3B,sCAAsC;EACtC,oCAAoC;EACpC,uCAAuC;EACvC,qCAAqC;EACrC,yCAAyC;EACzC,sCAAsC;EACtC,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE;qBACmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,sCAAsC;EACtC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,uFAAuF;AACzF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,yDAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,2CAA2C;EAC3C,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;;;;;EAKE,0BAA0B;EAC1B,+EAA+E;EAC/E,0BAA0B;AAC5B;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,uEAAuE;AACzE;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,uEAAuE;AACzE;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,sEAAsE;AACxE;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,oEAAoE;AACtE;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/*\n  Design tokens — soft UI + Azul Safira sóbrio\n  - Accent: #2B6CB0 (quebra o excesso de cinza)\n  - Neutros mantêm superfícies e tipografia equilibradas\n*/\n:root {\n  /* ——— Neutrals ——— */\n  --color-bg: #e8e8e8;\n  --color-bg-subtle: #f0f0f0;\n  --color-surface: #ffffff;\n  --color-surface-muted: #f3f3f3;\n  --color-text: #1a1a1a;\n  --color-text-secondary: #404040;\n  --color-text-muted: #666666;\n  --color-text-inverse: #fafafa;\n\n  /* ——— Accent: Azul Safira Sóbrio (destaque em todo o sistema) ——— */\n  --color-accent: #2b6cb0;\n  --color-accent-hover: #245a96;\n  --color-accent-active: #1e4d82;\n  --color-accent-fg: #ffffff;\n  --color-accent-muted: rgba(43, 108, 176, 0.1);\n  --color-accent-border: rgba(43, 108, 176, 0.28);\n  --color-accent-soft: rgba(43, 108, 176, 0.14);\n  /* Badges/tags de destaque (ultra-suave) */\n  --color-accent-badge-bg: #ebf8ff;\n  --color-accent-badge-fg: #2b6cb0;\n  --color-accent-badge-border: rgba(43, 108, 176, 0.14);\n\n  /* Emphasis = Accent (CTAs, abas ativas, punch next, etc.) */\n  --color-emphasis: var(--color-accent);\n  --color-emphasis-fg: var(--color-accent-fg);\n  --color-emphasis-hover: var(--color-accent-hover);\n  --color-emphasis-muted: var(--color-accent-muted);\n  --color-emphasis-border: var(--color-accent-border);\n\n  /* Primary = accent */\n  --color-primary: var(--color-accent);\n  --color-primary-hover: var(--color-accent-hover);\n  --color-primary-active: var(--color-accent-active);\n  --color-primary-fg: var(--color-accent-fg);\n  --color-primary-muted: var(--color-accent-muted);\n  --color-primary-border: var(--color-accent-border);\n  /* soft = pastel (nunca sólido — evita texto ilegível em avatares/chips) */\n  --color-primary-soft: var(--color-accent-badge-bg);\n  --color-primary-soft-hover: var(--color-accent-muted);\n\n  /* Semântica suave (badges/tags — pastel dessaturado + texto escuro) */\n  --color-danger: #991b1b;\n  --color-danger-muted: #fef2f2;\n  --color-success: #166534;\n  --color-success-muted: #f0fdf4;\n  --color-warning: #9a3412;\n  --color-warning-muted: #fff7ed;\n  --color-info: var(--color-accent);\n  --color-info-muted: rgba(43, 108, 176, 0.1);\n\n  /* ——— Borders (sutis, baixa opacidade) ——— */\n  --border-subtle: rgba(23, 23, 23, 0.06);\n  --border-default: rgba(23, 23, 23, 0.09);\n  --border-strong: rgba(23, 23, 23, 0.14);\n  --border-divider: rgba(23, 23, 23, 0.045);\n\n  /* ——— Radius ——— */\n  --radius-sm: 8px;\n  --radius-md: 10px;\n  --radius-lg: 12px;\n  --radius-full: 12px;\n  --input-radius: 10px;\n  --badge-radius: 8px;\n\n  /* ——— Elevation ——— */\n  --shadow-none: none;\n  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.03);\n  --shadow-sm: 0 4px 16px -6px rgba(0, 0, 0, 0.04);\n  --shadow-md: 0 10px 30px -10px rgba(0, 0, 0, 0.04);\n  --shadow-card: 0 10px 30px -10px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);\n  --shadow-elevated: 0 16px 40px -12px rgba(0, 0, 0, 0.08), 0 4px 14px -6px rgba(0, 0, 0, 0.04);\n  --elevation-border: 1px solid var(--border-subtle);\n  --focus-border-color: rgba(43, 108, 176, 0.5);\n  --focus-ring: 0 0 0 3px rgba(43, 108, 176, 0.16);\n  --focus-ring-accent: 0 0 0 3px rgba(43, 108, 176, 0.18);\n\n  /* ——— Superfícies ——— */\n  --surface-radius: 14px;\n  --surface-pad: 24px;\n  --surface-pad-lg: 28px;\n  --surface-gap: 20px;\n\n  /* ——— Button tokens ——— */\n  --btn-radius: 10px;\n  --btn-radius-sm: 8px;\n  --btn-shadow: none;\n  --btn-transition: border-color 200ms ease, background-color 200ms ease, color 200ms ease;\n  --btn-secondary-bg: #ffffff;\n  --btn-secondary-border: var(--border-default);\n  --btn-secondary-fg: var(--color-text-secondary);\n  --btn-secondary-hover-bg: #ffffff;\n  --btn-secondary-hover-border: var(--color-accent);\n  --btn-secondary-hover-fg: var(--color-accent);\n  --btn-primary-bg: var(--color-accent);\n  --btn-primary-hover: var(--color-accent-hover);\n  --btn-primary-fg: var(--color-accent-fg);\n\n  /* ——— Chrome: header glass + heroes ——— */\n  --surface-elevated: var(--color-surface);\n  --color-chrome: #eef3f9;\n  --color-chrome-gradient: linear-gradient(165deg, #f8fafc 0%, #eef3f9 52%, #e4ecf6 100%);\n  --color-chrome-border: rgba(43, 108, 176, 0.1);\n  --color-chrome-inset: inset 0 1px 0 rgba(255, 255, 255, 0.65);\n  --color-header-glass: rgba(255, 255, 255, 0.62);\n  --color-header-glass-blur: blur(14px) saturate(180%);\n  --color-hero: var(--color-chrome);\n  --color-hero-fg: #1a1a1a;\n  --color-hero-muted: #4a5568;\n  --color-hero-gradient: var(--color-chrome-gradient);\n  --color-page-gradient: linear-gradient(180deg, #e8eef5 0%, #e6e9ee 52%, #e3e5e8 100%);\n\n  /* ——— Legacy aliases ——— */\n  --surface-border: var(--border-subtle);\n  --surface-card: var(--color-surface);\n  --option-bg: var(--color-surface-muted);\n  --option-border: var(--border-subtle);\n  --option-hover-bg: var(--color-bg-subtle);\n  --option-focus-ring: var(--focus-ring);\n  --primary-gradient: var(--color-primary-soft);\n  --primary-shadow: var(--btn-shadow);\n}\n\nbody {\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',\n    Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--color-page-gradient);\n  background-color: var(--color-bg);\n  color: var(--color-text);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.card {\n  background: var(--surface-card);\n  border: var(--elevation-border);\n  border-radius: var(--surface-radius);\n  padding: var(--surface-pad);\n  margin-bottom: var(--surface-gap);\n  box-shadow: var(--shadow-card);\n}\n\n.btn {\n  padding: 10px 20px;\n  border: 1px solid transparent;\n  border-radius: var(--btn-radius);\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: var(--btn-transition);\n}\n\n.btn-primary {\n  background: var(--btn-primary-bg);\n  color: var(--btn-primary-fg);\n  box-shadow: none;\n  border-color: var(--color-primary);\n}\n\n.btn-primary:hover {\n  background: var(--btn-primary-hover);\n  border-color: var(--btn-primary-hover);\n  color: var(--btn-primary-fg);\n  filter: none;\n  transform: none;\n}\n\n.btn-primary:active {\n  background: var(--color-primary-active);\n  border-color: var(--color-primary-active);\n  box-shadow: var(--shadow-none);\n}\n\n.btn-secondary {\n  background: var(--btn-secondary-bg);\n  color: var(--btn-secondary-fg);\n  border-color: var(--btn-secondary-border);\n  box-shadow: var(--shadow-xs);\n}\n\n.btn-secondary:hover {\n  background: var(--btn-secondary-hover-bg);\n  border-color: var(--btn-secondary-hover-border);\n  color: var(--btn-secondary-hover-fg);\n}\n\n.btn-secondary:focus-visible {\n  outline: none;\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n  box-shadow: var(--focus-ring);\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border-default);\n  border-radius: var(--input-radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-size: 0.95rem;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.form-group select {\n  min-height: 44px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  padding-right: 40px;\n  background-color: var(--color-surface);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%2371717a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px 16px;\n}\n\n.form-group input:hover,\n.form-group select:hover,\n.form-group textarea:hover {\n  border-color: var(--border-default);\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border: 2px solid var(--focus-border-color);\n  background-color: var(--color-surface);\n  box-shadow: var(--focus-ring);\n}\n\n.form-group textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n/* Links de texto em prosa — não aplicar a CTAs/Links estilizados como botão */\n.app-main p a,\n.app-main li a,\n.app-main .dashboard-support-text a,\n.app-main .feedbacks-empty-card a,\n.app-main a.app-text-link {\n  color: var(--color-accent);\n  text-decoration-color: color-mix(in srgb, var(--color-accent) 35%, transparent);\n  text-underline-offset: 2px;\n}\n\n.app-main p a:hover,\n.app-main li a:hover,\n.app-main .dashboard-support-text a:hover,\n.app-main .feedbacks-empty-card a:hover,\n.app-main a.app-text-link:hover {\n  color: var(--color-accent-hover);\n}\n\n/* Badge / tag utilitário — cantos soft, pastel dessaturado */\n.ui-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  max-width: 100%;\n  padding: 4px 10px;\n  border-radius: var(--badge-radius);\n  border: 1px solid transparent;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.3;\n  box-sizing: border-box;\n  background: var(--color-surface-muted);\n  color: var(--color-text-secondary);\n}\n\n.ui-badge--accent {\n  background: var(--color-accent-badge-bg);\n  color: var(--color-accent-badge-fg);\n  border-color: var(--color-accent-badge-border);\n}\n\n.ui-badge--success {\n  background: var(--color-success-muted);\n  color: var(--color-success);\n  border-color: color-mix(in srgb, var(--color-success) 12%, transparent);\n}\n\n.ui-badge--warning {\n  background: var(--color-warning-muted);\n  color: var(--color-warning);\n  border-color: color-mix(in srgb, var(--color-warning) 12%, transparent);\n}\n\n.ui-badge--danger {\n  background: var(--color-danger-muted);\n  color: var(--color-danger);\n  border-color: color-mix(in srgb, var(--color-danger) 12%, transparent);\n}\n\n.ui-badge--info {\n  background: var(--color-info-muted);\n  color: var(--color-info);\n  border-color: color-mix(in srgb, var(--color-info) 10%, transparent);\n}\n\n.ui-badge--neutral {\n  background: var(--color-surface-muted);\n  color: var(--color-text-secondary);\n  border-color: var(--border-subtle);\n}\n\n/* Tabelas base — divisores suaves + hover discreto */\n.ui-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.ui-table th,\n.ui-table td {\n  padding: 12px 14px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-divider);\n}\n\n.ui-table tbody tr {\n  transition: background-color 0.15s ease;\n}\n\n.ui-table tbody tr:hover {\n  background: color-mix(in srgb, var(--color-emphasis) 3.5%, transparent);\n}\n\n.error {\n  color: var(--color-danger);\n  margin-top: 5px;\n}\n\n.success {\n  color: var(--color-success);\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
